import React from 'react';
import banner_01 from '../images/IMG_1726.jpg';
import python_icon from '../images/python.png';
import javascript_icon from '../images/icons8-javascript.svg';
import aws_icon from '../images/icons8-amazon-web-services.svg';
import facebook_icon from '../images/github-mark.png';
import instagram_icon from '../images/instagram.svg';
import linked_in_icon from '../images/linkedin.svg';

function Hero() {
    return (
        <div id="home" className="rn-slider-area">
            <div className="slide slider-style-1">
                <div className="container">
                    <div className="row row--30 align-items-center">
                        <div className="order-2 order-lg-1 col-lg-7 mt_md--50 mt_sm--50 mt_lg--30">
                            <div className="content">
                                <div className="inner">
                                    <span className="subtitle">Welcome to my world</span>
                                    <h1 className="title">
                                        Hi, I'm <span>Mukhtar Ahmad Zargar</span>
                                        <br />
                                        <span className="header-caption" id="page-top">
                                            <span className="cd-headline clip is-full-width">
                                                <span>a </span>
                                                <span className="cd-words-wrapper">
                                                    <b className="is-visible">Software Engineer.</b>
                                                    <b className="is-hidden">Technical Lead.</b>
                                                    <b className="is-hidden">Full Stack Developer.</b>
                                                </span>
                                            </span>
                                        </span>
                                    </h1>
                                    <div>
                                        <p className="description">
                                            Full Stack Developer with 4+ years of experience specializing in Python, Django, and Django REST Framework.
                                            Strong expertise in building scalable web applications, REST APIs, and full-stack solutions. Experienced in
                                            backend development, frontend implementation, database design, and cloud deployments. Proven track record
                                            of delivering production-grade applications handling high-volume transactions and complex business workflows.
                                            Skilled in modern web technologies, API integrations, and system architecture.
                                        </p>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12">
                                        <div className="social-share-inner-left">
                                            <span className="title">find with me</span>
                                            <ul className="social-share d-flex liststyle">
                                                <li className="instagram">
                                                    <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/maaan_g/">
                                                        <img src={instagram_icon} alt="Instagram" />
                                                    </a>
                                                </li>
                                                <li className="linkedin">
                                                    <a target="_blank" rel="noopener noreferrer" href="https://www.linkedin.com/in/mukhtar-ahmad-zargar/">
                                                        <img src={linked_in_icon} alt="LinkedIn" />
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-lg-6 col-xl-6 col-md-6 col-sm-6 col-12 mt_mobile--30">
                                        <div className="skill-share-inner">
                                            <span className="title">best skill on</span>
                                            <ul className="skill-share d-flex liststyle">
                                                <li>
                                                    <img src={python_icon} alt="Python" />
                                                </li>
                                                <li>
                                                    <img src={javascript_icon} alt="JavaScript" />
                                                </li>
                                                <li>
                                                    <img src={aws_icon} alt="AWS" />
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="order-1 order-lg-2 col-lg-5">
                            <div className="thumbnail">
                                <div className="inner">
                                    <img src={banner_01} alt="Mukhtar Ahmad Zargar" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Hero;
